import { getDefaultDBEntityDocument, } from "utils-library/dist/db-entity-interfaces";
export const getDefaultAppOptions = () => getDefaultDBEntityDocument({ deleteForeverAfterDays: 30 });
